export const RouterSettings = {
  /** 首頁 */
  Home: `${process.env.REACT_APP_PREFIX}/home`,
  /** 登入頁 */
  Login: `${process.env.REACT_APP_PREFIX}/login`,
  /** 會員註冊頁 */
  Signup: `${process.env.REACT_APP_PREFIX}/signup`,
  /** 我的收藏頁 */
  FavoriteList: `${process.env.REACT_APP_PREFIX}/favorite-list`,
  /** 旅遊險投保作業 */
  Insure_Process: `${process.env.REACT_APP_PREFIX}/insure-process`,
  /** 旅遊險投保作業 (補繳費) */
  Insure_Process_UUID: `${process.env.REACT_APP_PREFIX}/insure-process/:uuid`,
  /** 會員解鎖頁 */
  Unlock: `${process.env.REACT_APP_PREFIX}/unlock/:uuid`,
  /** 商品資訊 */
  Product: {
    /** 商品資訊 - 旅遊險首頁 */
    TravelIns: `${process.env.REACT_APP_PREFIX}/product/travel-ins`,
    /** 商品資訊 - 旅遊險首頁 (含優惠代碼) */
    TravelIns_ProgramId: `${process.env.REACT_APP_PREFIX}/product/travel-ins/:programId`,
    /** 商品資訊 - 寵物險首頁 */
    PetIns: `${process.env.REACT_APP_PREFIX}/product/pet-ins`,
    /** 商品資訊 - 汽車險首頁 */
    CarIns: `${process.env.REACT_APP_PREFIX}/product/car-ins`,
    /** 商品資訊 - 汽車險首頁 (含優惠代碼) */
    CarIns_ProgramId: `${process.env.REACT_APP_PREFIX}/product/car-ins/:programId`,
    /** 商品資訊 - 電車險首頁 */
    ECarIns: `${process.env.REACT_APP_PREFIX}/product/ecar-ins`,
    /** 商品資訊 - 電車險首頁 (含優惠代碼) */
    ECarIns_ProgramId: `${process.env.REACT_APP_PREFIX}/product/ecar-ins/:programId`,
    /** 商品資訊 - 機車險首頁 */
    MotoIns: `${process.env.REACT_APP_PREFIX}/product/moto-ins`,
    /** 商品資訊 - 機車險首頁 (含優惠代碼) */
    MotoIns_ProgramId: `${process.env.REACT_APP_PREFIX}/product/moto-ins/:programId`,
    /** 商品資訊 - 行動裝置險首頁 */
    MobileDeviceIns: `${process.env.REACT_APP_PREFIX}/product/mobile-device-ins`,
    /** 商品資訊 - 行動裝置險首頁 (含優惠代碼) */
    MobileDeviceIns_ProgramId: `${process.env.REACT_APP_PREFIX}/product/mobile-device-ins/:programId`,
    /** 商品資訊 - 住火險首頁 */
    FireIns: `${process.env.REACT_APP_PREFIX}/product/fire-ins`,
    /** 商品資訊 - 住火險首頁 (含優惠代碼) */
    FireIns_ProgramId: `${process.env.REACT_APP_PREFIX}/product/fire-ins/:programId`
  },
  /** 優惠活動 */
  Promotions: {
    /** 優惠活動 - 優惠活動列表頁 */
    List: `${process.env.REACT_APP_PREFIX}/promotions/list`,
    /** 優惠活動 - 活動內頁 */
    InnerPage: `${process.env.REACT_APP_PREFIX}/promotions/inner-page`,
    /** 優惠活動 - 活動內頁 A */
    InnerPageA: `${process.env.REACT_APP_PREFIX}/promotions/inner-page-a`,
    /** 優惠活動 - 活動內頁 B */
    InnerPageB: `${process.env.REACT_APP_PREFIX}/promotions/inner-page-b`,
    /** 優惠活動 - 活動內頁 C */
    InnerPageC: `${process.env.REACT_APP_PREFIX}/promotions/inner-page-c`,
    /** 優惠活動 - 得獎公告 */
    Announcement: `${process.env.REACT_APP_PREFIX}/promotions/announcement`,
    /** 優惠活動 - 加值服務 */
    Service: `${process.env.REACT_APP_PREFIX}/promotions/service`
  },
  /** 最新消息 */
  News: {
    /** 最新消息 - 資訊分享列表頁 */
    List: `${process.env.REACT_APP_PREFIX}/news/list`,
    /** 最新消息 - 公司公告 */
    Announcement: `${process.env.REACT_APP_PREFIX}/news/announcement`,
    /** 最新消息 - 部落客文章 */
    Article: `${process.env.REACT_APP_PREFIX}/news/article`,
    /** 最新消息 - 公司影音 */
    Video: `${process.env.REACT_APP_PREFIX}/news/video`,
    /** 最新消息 - 新聞稿 */
    Release: `${process.env.REACT_APP_PREFIX}/news/release`
  },
  /** 會員中心 */
  MemberCenter: {
    /** 會員資料維護 */
    MemberMaintain: `${process.env.REACT_APP_PREFIX}/member-center/member-maintain`,
    /** 電子式保單 */
    ElectronicPolicy: `${process.env.REACT_APP_PREFIX}/member-center/electronic-policy`,
    /** 班機延誤快速理賠 */
    // QuickClaims: `${process.env.REACT_APP_PREFIX}/member-center/quick-claims`,
    /** 抽獎活動 */
    Game: `${process.env.REACT_APP_PREFIX}/member-center/game`,
    /** 保單查詢 */
    PolicyInquiry: `${process.env.REACT_APP_PREFIX}/member-center/policy-inquiry`,
    /** 保單明細 - 旅遊險 */
    PolicyDetailTravel: `${process.env.REACT_APP_PREFIX}/member-center/policy-inquiry/travel/detail`,
    /** 保單明細 - 汽車險 */
    PolicyDetailCar: `${process.env.REACT_APP_PREFIX}/member-center/policy-inquiry/car/detail`,
    /** 保單明細 - 機車險 */
    PolicyDetailMoto: `${process.env.REACT_APP_PREFIX}/member-center/policy-inquiry/moto/detail`,
    /** 保單明細 - 住宅火險 */
    PolicyDetailFire: `${process.env.REACT_APP_PREFIX}/member-center/policy-inquiry/fire/detail`,
    /** 保單明細 - 行動裝置險 */
    PolicyDetailMobileDevice: `${process.env.REACT_APP_PREFIX}/member-center/policy-inquiry/mobile-device/detail`,
    /** 保單明細 - 寵物險 */
    PolicyDetailPet: `${process.env.REACT_APP_PREFIX}/member-center/policy-inquiry/pet/detail`,
    /** 批改文件下載 */
    CorrectionDownload: `${process.env.REACT_APP_PREFIX}/member-center/correction-download`,
    /** 批改申請 - 旅遊險 */
    CorrectionTravel: `${process.env.REACT_APP_PREFIX}/member-center/correction/travel`,
    /** 批改申請 - 汽車險 */
    CorrectionCar: `${process.env.REACT_APP_PREFIX}/member-center/correction/car`,
    /** 批改申請 - 機車險 */
    CorrectionMoto: `${process.env.REACT_APP_PREFIX}/member-center/correction/moto`,
    /** 批改申請 - 住宅火險 */
    CorrectionFire: `${process.env.REACT_APP_PREFIX}/member-center/correction/fire`,
    /** 批改申請 - 預覽畫面 */
    CorrectionPreview: `${process.env.REACT_APP_PREFIX}/member-center/correction/preview`,
    /** 理賠服務 - 旅遊險 */
    ClaimService: `${process.env.REACT_APP_PREFIX}/member-center/claim-service`,
    /** 理賠服務 - 旅遊險 */
    ClaimServiceTravel: `${process.env.REACT_APP_PREFIX}/member-center/claim-service/travel`,
    /** 理賠服務 - 汽車險 */
    ClaimServiceCar: `${process.env.REACT_APP_PREFIX}/member-center/claim-service/car`,
    /** 理賠服務 - 機車險 */
    ClaimServiceMoto: `${process.env.REACT_APP_PREFIX}/member-center/claim-service/moto`,
    /** 理賠服務 - 住宅火險 */
    ClaimServiceFire: `${process.env.REACT_APP_PREFIX}/member-center/claim-service/fire`,
    /** 理賠服務 - 行動裝置險 */
    ClaimServiceMobileDevice: `${process.env.REACT_APP_PREFIX}/member-center/claim-service/mobile`
  },
  /** 投保作業 */
  InsureProcess: {
    /** 投保作業 - 旅遊險 */
    Travel: `${process.env.REACT_APP_PREFIX}/insure-process/travel`,
    /** 投保作業 - 旅遊險 (補繳費) */
    Travel_UUID: `${process.env.REACT_APP_PREFIX}/insure-process/travel/:uuid`,
    /** 投保作業 - 汽車險 */
    Car: `${process.env.REACT_APP_PREFIX}/insure-process/car`,
    /** 投保作業 - 汽車險(補繳費) */
    Car_UUID: `${process.env.REACT_APP_PREFIX}/insure-process/car/:uuid`,
    /** 投保作業 - 機車險 */
    Moto: `${process.env.REACT_APP_PREFIX}/insure-process/moto`,
    /** 投保作業 - 機車險(補繳費) */
    Moto_UUID: `${process.env.REACT_APP_PREFIX}/insure-process/moto/:uuid`,
    /** 投保作業 - 行動裝置險 */
    MobileDevice: `${process.env.REACT_APP_PREFIX}/insure-process/mobile`,
    /** 投保作業 - 行動裝置險(手機檢測結果) */
    MobileDevice_Device_Check_Complete: `${process.env.REACT_APP_PREFIX}/insure-process/mobile/:queryString`,
    /** 投保作業 - 寵物險 */
    Pet: `${process.env.REACT_APP_PREFIX}/insure-process/pet`,
    /** 投保作業 - 住宅火險 */
    Fire: `${process.env.REACT_APP_PREFIX}/insure-process/fire`,
    /** 投保作業 - 住宅火險 (補繳費) */
    Fire_UUID: `${process.env.REACT_APP_PREFIX}/insure-process/fire/:uuid`,
    ECar: `${process.env.REACT_APP_PREFIX}/insure-process/ecar`
  },
  /** 勘車拍照 (僅手機版) */
  SurveyVehicle: `${process.env.REACT_APP_PREFIX}/survey-vehicle`,
  /** 勘車拍照 (僅手機版 UUID 補拍照) */
  SurveyVehicle_UUID: `${process.env.REACT_APP_PREFIX}/survey-vehicle/:uuid`
};
